import PreferencesFilterList from 'components/PreferencesFilterList/PreferencesFilterList';

export default PreferencesFilterList;
